import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ChangeDetectionStrategy,
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LegalEntity } from '../../model/legal-entity/legal-entity';
import { LegalEntityService } from '../../services/api/legal-entity.service';
import { MatDialog } from '@angular/material/dialog';
import { Employee } from '../../model/employee/employee';
import { EditLegalEntityDialogComponent } from '../dialogs/edit-legal-entity-dialog/edit-legal-entity-dialog.component';

@Component({
  selector: 'app-personal-information-legal-entity',
  templateUrl: './personal-information-legal-entity.component.html',
  styleUrls: ['./personal-information-legal-entity.component.scss'],
  providers: [LegalEntityService],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PersonalInformationLegalEntityComponent implements OnChanges {
  @Input() employee: Employee | null = null;

  protected readonly legalEntity$ = new BehaviorSubject<LegalEntity | null>(
    null,
  );

  constructor(
    private readonly legalEntityService: LegalEntityService,
    private readonly dialog: MatDialog,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if ('employee' in changes) {
      this.updateLegalEntity();
    }
  }

  onChangeLegalEntity() {
    if (!this.employee) {
      return;
    }

    const dialogRef = this.dialog.open(EditLegalEntityDialogComponent, {
      data: this.employee,
      minWidth: '25rem',
    });

    dialogRef.afterClosed().subscribe((result: Employee) => {
      if (result) {
        this.employee = result;
        this.updateLegalEntity();
      }
    });
  }

  private updateLegalEntity() {
    const legalEntityId = this.employee?.legalEntityId;
    if (!legalEntityId) {
      this.legalEntity$.next(null);
      return;
    }

    this.legalEntityService
      .getLegalEntity(legalEntityId)
      .subscribe((legalEntity) => this.legalEntity$.next(legalEntity));
  }
}
